import { render, staticRenderFns } from "./LoaderOpaque.vue?vue&type=template&id=33ee7852&"
import script from "./LoaderOpaque.vue?vue&type=script&lang=js&"
export * from "./LoaderOpaque.vue?vue&type=script&lang=js&"
import style0 from "./LoaderOpaque.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports